import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'agr-no-access',
  templateUrl: './no-access.component.html',
  styleUrls: ['./403-and-404.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NoAccessComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
